import { endpoints } from '../../../config';
import appClient from '../../common/services/AppClient';
import {
    SearchAdministrationHistoryFilter,
    SearchAdministrationHistoryResult,
    SearchHistoryFilter,
    SearchHistoryResult
} from './types';

export default class HistoryService {
    async searchHistory(filter: SearchHistoryFilter) {
        const url = `${endpoints.manageUrl}history/search`;
        const result = await appClient.post<SearchHistoryResult['searchHistory']>(url, filter);
        const response = result.unwrapOr({ historyRecords: [], total: 0 });

        return {
            historyRecords: response.historyRecords,
            total: response.total
        };
    }

    async searchAdministrationHistory(filter: SearchAdministrationHistoryFilter) {
        const url = `${endpoints.manageUrl}history/administration/search`;
        const result = await appClient.post<SearchAdministrationHistoryResult['searchAdministrationHistory']>(
            url,
            filter
        );
        const response = result.unwrapOr({ historyRecords: [], total: 0 });

        return {
            historyRecords: response.historyRecords,
            total: response.total
        };
    }
}
